export default "__VITE_ASSET__CU5LnUk2__"